/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable @next/next/no-html-link-for-pages */

import { Link, Box } from "@chakra-ui/react";
import IndexLayout from "../../components/base_layout";

import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUpRightFromSquare } from "@fortawesome/free-solid-svg-icons";

const axios = require("axios").default;

export default function CategoryMenuHome() {
  const [major, setMajor] = useState("");
  const [middle, setMiddle] = useState("");
  const [minor, setMinor] = useState("");
  const [majorTitleNumber, setMajorTitleNumber] = useState("");
  const [majorTitle, setMajorTitle] = useState("");
  const [middleTitleNumber, setMiddleTitleNumber] = useState("");
  const [middleTitle, setMiddleTitle] = useState("");

  const getMajorData = async () => {
    const majorURL =
      process.env.PANDA_API_URL + `/api/mall/getCategorySub/major`;
    const majorRes = await axios.get(majorURL, {
      headers: {
        "content-type": "application/json",
      },
    });
    setMajor(majorRes.data.data);

    if (majorRes.data.data.length > 0) {
      const first = majorRes.data.data[0];
      changeMiddle(first.ca_id, first.ca_name_kr);
    }
  };

  const changeMiddle = async (ca_id, ca_name_kr) => {
    // 기본적인 대분류 클릭시 관련 중분류 세팅
    const middleURL =
      process.env.PANDA_API_URL + `/api/mall/getRelatedCategories`;

    const middleBody = {
      ca_id: ca_id,
      ca_type: "middle",
    };

    try {
      const middleRes = await axios.post(middleURL, middleBody, {
        headers: {
          "content-type": "application/json",
        },
      });

      const middleList = middleRes.data.data;

      setMajorTitleNumber(ca_id);
      setMajorTitle(ca_name_kr);
      setMiddle(middleList);

      if (middleList.length > 0) {
        const first = middleList[0];
        setMiddleTitleNumber(first.ca_id);
        setMiddleTitle(first.ca_name_kr);

        // 클릭한 대분류의 첫번째 중분류와 관련된 소분류 데이터 로딩
        const minorURL =
          process.env.PANDA_API_URL + `/api/mall/getRelatedCategories`;

        const minorBody = {
          ca_id: first.ca_id,
          ca_type: "minor",
        };

        const minorRes = await axios.post(minorURL, minorBody, {
          headers: {
            "content-type": "application/json",
          },
        });

        setMinor(minorRes.data.data);
      } else {
        // 중분류가 없는 경우 완전 초기화
        setMiddleTitleNumber("");
        setMiddleTitle("");
        setMinor("");
      }
    } catch (error) {
      console.error("Error in changeMiddle:", error);
    }
  };

  const changeMinor = async (ca_id, ca_name_kr) => {
    const minorURL =
      process.env.PANDA_API_URL + `/api/mall/getRelatedCategories`;

    const minorBody = {
      ca_id: ca_id,
      ca_type: "minor",
    };

    const middleRes = await axios.post(minorURL, minorBody, {
      headers: {
        "content-type": "application/json",
      },
    });

    setMiddleTitleNumber(ca_id);
    setMiddleTitle(ca_name_kr);
    setMinor(middleRes.data.data);
  };

  const getCategoryHref = (ca_id) => {
    const caIdStr = ca_id.toString();
    const prefix = caIdStr.substring(0, 2);

    if (
      prefix === "11" ||
      prefix === "14" ||
      prefix === "15" ||
      prefix === "16" ||
      prefix === "32"
    ) {
      return `/parts/mallcategory/${ca_id}`;
    }

    return `/parts/category/${ca_id}`;
  };

  useEffect(() => {
    getMajorData();
  }, []);

  return (
    <IndexLayout>
      <Box id="category_wrap">
        <Box>
          <Box className="category_major">
            <ul>
              {major.length > 0
                ? major.map((i) => (
                    <li
                      className={majorTitleNumber == i.ca_id ? "active" : ""}
                      value={i.ca_id}
                      onClick={() => changeMiddle(i.ca_id, i.ca_name_kr)}
                    >
                      <p>{i.ca_name_kr}</p>
                      <a href={getCategoryHref(i.ca_id)}>
                        <img src="../../images/link_from_site.png" />
                      </a>
                    </li>
                  ))
                : ""}
            </ul>
          </Box>
          <Box className="category_middle">
            <Box className="category_middle_tit">
              <nav>
                <span>카테고리</span>

                <>
                  <em>{majorTitle ? "/" : ""}</em>
                  <strong>{majorTitle}</strong>
                </>

                <>
                  <em>{middleTitle ? "/" : ""}</em>
                  <span> {middleTitle} </span>
                </>
              </nav>
              <h3>{middleTitle}</h3>
            </Box>
            <ul className="category_middle_lists">
              {middle.length > 0
                ? middle.map((i) => (
                    <li
                      className={middleTitleNumber == i.ca_id ? "active" : ""}
                      key={i.ca_id}
                      value={i.ca_id}
                      onClick={() => changeMinor(i.ca_id, i.ca_name_kr)}
                    >
                      <p>{i.ca_name_kr}</p>
                      <a href={getCategoryHref(i.ca_id)}>
                        <img src="../../images/link_from_site.png" />
                      </a>
                    </li>
                  ))
                : ""}
            </ul>
          </Box>
          <Box className="category_minor">
            <ul>
              {minor.length > 0
                ? minor.map((i) => (
                    <li>
                      <a href={getCategoryHref(i.ca_id)}>
                        <p>{i.ca_name_kr} </p>
                        <img src="../../images/link_from_site.png" />
                      </a>
                    </li>
                  ))
                : ""}
            </ul>
          </Box>
        </Box>
      </Box>
    </IndexLayout>
  );
}
